import styled from "styled-components"
import { mobile, tablet, smallScreen } from "../../Responsive"

export const Container = styled.div`
   background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
   min-height: 85vh;
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 50px;

   ${tablet({ gap: "20px" })}
   ${mobile({ padding: "10px" })}
`
export const Left = styled.div`
   flex: 1;
   display: flex;
   flex-direction: column;
`

export const StyledForm = styled.form`
   flex: 1;
   margin: 0px 50px;
   padding: 20px;
   background-color: ${({ theme }) => theme.body};
   opacity: 0.8;
   display: flex;
   align-items: center;
   flex-direction: column;

   ${tablet({ padding: "15px", margin: "0px 20px" })}
   ${mobile({ padding: "10px", margin: "0px 0px" })}
`

export const Title = styled.h1`
   font-weight: 300;
   text-align: center;
`

export const StyledInput = styled.input`
   width: 90%;
   padding: 10px;
   margin: 10px 0;
   background-color: transparent;
   color: ${({ theme }) => theme.text};
   border: 1px solid var(--primary);
   transition: all 0.5s ease;
   font-size: var(--fontS);

   :focus {
      border: 1px solid var(--secondary);
      outline: none;
   }

   ::placeholder {
      color: ${({ theme }) => theme.text};
   }

   @media screen and (max-width: ${smallScreen}) {
      font-size: var(--fontS);
   }
`

export const StyledTextArea = styled.textarea`
   width: 90%;
   padding: 10px;
   margin: 10px 0;
   background-color: ${({ theme }) => theme.body};
   color: ${({ theme }) => theme.text};
   border: 1px solid var(--primary);
   border-radius: 5px;

   ::placeholder {
      color: ${({ theme }) => theme.text};
   }

   :focus {
      border: 1px solid var(--secondary);
      outline: none;
   }
`

export const Message = styled.p`
   color: var(--secondary);
`

export const MapWrapper = styled.div`
   flex: 1;
   height: 100%;
   min-height: 85vh;

   ${mobile({ display: "none" })}
`

export const RegionNote = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   flex-direction: column;
   gap: 20px;

   ${tablet({ gap: "10px" })}
   ${mobile({ padding: "10px" })}
`

export const RegionText = styled.p`
   margin: 0px 50px;
   padding: 20px;
`

export const RegionLogo = styled.img`
   display: block;
   margin: 1rem auto;
   max-width: 150px;
   height: auto;
   object-fit: contain;
`
